import { render } from "./FellowPreviewDialog.vue?vue&type=template&id=2a467d66&scoped=true"
import script from "./FellowPreviewDialog.vue?vue&type=script&lang=js"
export * from "./FellowPreviewDialog.vue?vue&type=script&lang=js"

import "./FellowPreviewDialog.vue?vue&type=style&index=0&id=2a467d66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a467d66"]])

export default __exports__